import { getToken, getUser } from "../../Utilities/Common";
import { getWithParamsAPICall } from "../axiosMethodCall";

export const getInventories = async (params) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...params,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "inventories/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getInventoriesLogs = async (params) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...params,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "inventories/history",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
